import LogsList from "./pages/LogsList.vue";

export default {
    LogsList,
};
